export const extractBadgeIdFromPath = (path: string) => {
  const splittedImagePath = path.split('/');
  return splittedImagePath[splittedImagePath.length - 1];
};
